import { render, staticRenderFns } from "./BuddycomCallSelectTargetGroup.vue?vue&type=template&id=0a711f7e&scoped=true"
import script from "./BuddycomCallSelectTargetGroup.vue?vue&type=script&lang=js"
export * from "./BuddycomCallSelectTargetGroup.vue?vue&type=script&lang=js"
import style0 from "./BuddycomCallSelectTargetGroup.vue?vue&type=style&index=0&id=0a711f7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a711f7e",
  null
  
)

export default component.exports